<div class="dn-slider" >

  <div class="last-slider" [style.background-image]="lastBackground?'url(' + (lastBackground | safeResource) + '?w=1920&format=jpg)':''">

  </div>

  <div class="dn-slider-main-container" (swipeleft)="onSwipeLeft($event)" (swiperight)="onSwipeRight($event)">
    <ng-container *ngFor="let item of items; let idx = index">
      <a [routerLink]="[item.path,item.listPath]" class="dn-slider-image-placeholder"
        [ngClass]="{active: index === idx}"
        [style.background-image]="item.loaded?'url(' + (item.image | safeResource) + '?w=1920&format=jpg)':''"
        *ngIf="!item.external" title="{{item.title}}">
      </a>
      <a [href]="item.url" class="dn-slider-image-placeholder" [ngClass]="{active: index === idx}" target="_blank"
        [style.background-image]="item.loaded?'url(' + (item.image | safeResource) + '?w=1920&format=jpg)':''"
        *ngIf="item.external" title="{{item.title}}">
      </a>
    </ng-container>
  </div>
  <div class="container sidenav-outer-container">
    <div class="dn-slider-sidenav-container" *ngIf="items.length && navigator ==='sidebar'">
      <ul class="nav-link-ctn">
        <li *ngFor="let item of items; let idx = index">
          <div class="nav-link" (mouseenter)="onThumbnailMouseEnter(idx, $event)"
            (mouseleave)="onThumbnailMouseLeave($event)" [ngClass]="{active: index === idx}">
            <a [routerLink]="[item.path,item.listPath]" *ngIf="!item.external" class="a-link">
              <div class="main-link-title">{{ item.title }}</div>
              <div class="sub-link-title" *ngIf="item.subTitle">{{ item.subTitle }}</div>
            </a>
            <a [href]="item.url" *ngIf="item.external" target="_blank" class="a-link">
              <div class="main-link-title">{{ item.title }}</div>
              <div class="sub-link-title" *ngIf="item.subTitle">{{ item.subTitle }}</div>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
 
</div>

<ng-content></ng-content>